import React from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import {Col, Row} from "antd";
import "./ServiceSecDesktop.scss";

function ServiceSecDesktop({item,left,left_bottom,left_top,LinkDispatcher}){


    return(

        <Row gutter={[16,4]} justify="center"  className="component-row">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24}} >
                <div className="service-row">

                    {item.items.map(i=>{

                        let  btn = null;
                        let  color = null;

                        if(i.subtitle){
                            btn = i.subtitle.split("@")[0]
                            color = i.subtitle.split("@")[1]
                        }


                        return(
                            <div className="service-item">

                                <div className="service-item-img">
                                    <img src={i.image} alt=""/>
                                </div>

                                <div className="service-item-title">
                                    <h5>{i.title}</h5>
                                </div>

                                <div className="service-item-desc">
                                    <p>{i.text.substr(0,400)+"..."}</p>
                                </div>

                                <div className="service-item-btns" onClick={e=>{
                                    LinkDispatcher(i.link_to, i)
                                }}>
                                    <span style={{backgroundColor:color?color:"#999999"}}>{btn?btn:"بیشتر"}</span>
                                </div>

                            </div>
                        )
                    })}

                </div>
            </Col>
        </Row>

    )
}

export default ServiceSecDesktop
